// src/components/NotificationPanel.jsx

import { Trash2, X } from "lucide-react";
import { useNotifications } from "../Context/NotificationContext";
import { ViewNotification } from "../services/Notification/NotificationApi";

const NotificationPanel = ({ isOpen, onClose }) => {
    const {
        notifications,
        markAllRead,
        deleteNotification,
        setSelectedNotification,
        setIsNotificationUpdate
    } = useNotifications();

    const handleViewDetails = (n) => {

        ViewNotificationData(n?.notificationKeyID);
        setSelectedNotification(n);

    }

    const ViewNotificationData = async (notificationKeyID) => {
        try {
            const response = await ViewNotification(notificationKeyID);
            if (response.data?.statusCode === 200) {
                const list = response.data?.responseData?.data || [];
                setIsNotificationUpdate(true)

            }

        } catch (error) {

            console.log(error);
        }
    };
    return (
        <div
            onClick={(e) => e.stopPropagation()}
            className={`fixed top-14 right-2 w-80 bg-white shadow-xl rounded-lg border 
      transition-all duration-300 z-50
      ${isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"}
      md:right-10 md:w-96`}
        >
            <div className="flex justify-between items-center px-4 py-3 border-b">
                <h2 className="text-lg font-semibold">Notifications</h2>
                <button onClick={onClose} className="p-1 rounded hover:bg-gray-100">
                    <X size={20} className="text-gray-600 hover:text-gray-800" />
                </button>

            </div>

            <div className="max-h-80 overflow-y-auto">
                {notifications.map((n) => (
                    <div
                        key={n.id}
                        className={`p-4 border-b cursor-pointer flex justify-between items-start  ${n.isViewed ? "bg-white" : "bg-blue-100"
                            }`}
                    >
                        {/* Click Area → Open details */}
                        <div
                            onClick={() => handleViewDetails(n)}
                            className="flex-1"
                        >
                            <p className="font-medium">{n.title}</p>
                            <p className="text-sm text-gray-600">{n.message}</p>
                            <p className="text-xs text-gray-400 mt-1">{n.createdOnDate}</p>
                        </div>

                        {/* Delete Button */}
                        <button
                            onClick={() => deleteNotification(n)}
                            className="ml-3 text-red-500 hover:text-red-700"
                        >
                            <Trash2 size={18} />
                        </button>
                    </div>
                ))}
                {notifications?.length === 0 && (
                    <div className="m-3 flex justify-center">
                        <h3>No notification availble</h3>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationPanel;
